import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/smeetz_logo_black.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3138cc09"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "navbar",
  role: "navigation",
  "aria-label": "main navigation"
};
var _hoisted_2 = {
  class: "d-flex flex-row fl-j-c"
};
var _hoisted_3 = {
  class: "navbar-brand"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo",
    width: "25"
  }, null, -1);
});

var _hoisted_5 = {
  class: "navbar-end"
};
var _hoisted_6 = {
  class: "navbar-item"
};
var _hoisted_7 = {
  class: "navbar-item"
};
var _hoisted_8 = {
  class: "navbar-item"
};
var _hoisted_9 = {
  class: "navbar-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  var _component_NavbarTabs = _resolveComponent("NavbarTabs");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_intercom = _resolveComponent("intercom");

  var _component_navbar_reload_config = _resolveComponent("navbar-reload-config");

  var _component_navbar_scan_qr_code = _resolveComponent("navbar-scan-qr-code");

  var _component_navbar_detect_internet = _resolveComponent("navbar-detect-internet");

  var _component_navbar_main_menu = _resolveComponent("navbar-main-menu");

  return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    to: {
      path: '/'
    },
    class: "navbar--logo navbar-item",
    tag: "div"
  }, {
    default: _withCtx(function () {
      return [_hoisted_4];
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_5, [_ctx.isAuth && !_ctx.isClosingCashfloat ? (_openBlock(), _createBlock(_Suspense, {
    key: 0
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_NavbarTabs)];
    }),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_divider, {
    direction: "vertical",
    style: {
      "margin-left": "20px"
    }
  }), _createElementVNode("div", _hoisted_6, [_createVNode(_component_intercom)]), _createVNode(_component_el_divider, {
    direction: "vertical"
  }), _createElementVNode("div", _hoisted_7, [_createVNode(_component_navbar_reload_config)]), _ctx.isAuth && _ctx.hasSalesStarted ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createVNode(_component_el_divider, {
    direction: "vertical"
  }), _createElementVNode("div", _hoisted_8, [_createVNode(_component_navbar_scan_qr_code)])], 64)) : _createCommentVNode("", true), _createVNode(_component_el_divider, {
    direction: "vertical"
  }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_navbar_detect_internet)]), _ctx.isAuth ? (_openBlock(), _createBlock(_component_el_divider, {
    key: 2,
    direction: "vertical"
  })) : _createCommentVNode("", true), _ctx.isAuth ? (_openBlock(), _createBlock(_component_navbar_main_menu, {
    key: 3,
    class: "navbar-item has-cursor"
  })) : _createCommentVNode("", true)])]);
}